import {
  TProcessBoardsProcessList,
  TRESPONSE_GET_CAPACITY_BOARD,
  TRESPONSE_GET_ORDER_TIMELINE_VIEW,
  TRESPONSE_GET_PLANNING_BOARD,
} from '@monorepo/types';

export type TProcessBoardFetchState = 'loading' | 'loaded' | 'error';

export type TProcessBoardsState = {
  capacityBoardInfo: TRESPONSE_GET_CAPACITY_BOARD | null;
  capacityBoardFetchState: TProcessBoardFetchState;
  planningBoardInfo: TRESPONSE_GET_PLANNING_BOARD | null;
  planningBoardFetchState: TProcessBoardFetchState;
  orderTimelineViewBoardInfo: TRESPONSE_GET_ORDER_TIMELINE_VIEW | null;
  orderTimelineViewBoardFetchState: TProcessBoardFetchState;
  selectedProcessId: string | null;
  allProcesses: TProcessBoardsProcessList;
};

export const TProcessBoardsActionType = {
  FetchCapacityBoardListing: 'FETCH_CAPACITY_BOARD_LISTING' as const,
  FetchCapacityBoardListingSuccess: 'FETCH_CAPACITY_BOARD_LISTING_SUCCESS' as const,
  FetchCapacityBoardListingFailure: 'FETCH_CAPACITY_BOARD_LISTING_FAILURE' as const,
  FetchPlanningBoardListing: 'FETCH_PLANNING_BOARD_LISTING' as const,
  FetchPlanningBoardListingSuccess: 'FETCH_PLANNING_BOARD_LISTING_SUCCESS' as const,
  FetchPlanningBoardListingFailure: 'FETCH_PLANNING_BOARD_LISTING_FAILURE' as const,
  FetchOrderTimelineViewBoardListing: 'FETCH_ORDER_TIMELINE_VIEW_BOARD_LISTING' as const,
  FetchOrderTimelineViewBoardListingSuccess: 'FETCH_ORDER_TIMELINE_VIEW_BOARD_LISTING_SUCCESS' as const,
  FetchOrderTimelineViewBoardListingFailure: 'FETCH_ORDER_TIMELINE_VIEW_BOARD_LISTING_FAILURE' as const,
  SetSelectedProcessId: 'SET_SELECTED_PROCESS_ID' as const,
};
